"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabListStyle = exports.TabList = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["children", "classes", "className", "theme"];
/*:: // 

import { type Node } from 'react';*/
/*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var TabListStyle = exports.TabListStyle = function TabListStyle(theme /*: ThemeType*/) {
  return {
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      marginBottom: '1.25rem',
      boxShadow: "inset 0 -1px 0 0 ".concat(theme.colors.lightGrey),
      overflow: 'auto'
    }
  };
};
/*:: type Props = InjectSheetProvidedProps & { children?: Node };*/
var TabList = exports.TabList = function TabList(_ref /*:: */) {
  var children = _ref /*:: */.children,
    classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement("ul", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props), children);
};
TabList.displayName = 'TabList';
var _default = exports.default = (0, _injectSheet.default)(TabListStyle)(TabList);
//# sourceMappingURL=TabList.js.map